import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {MetaTagType} from "../../catalogue/meta-tag/meta-tag.data";

@Injectable()
export class OrderReadyQualifierSearchModel extends SearchModel<any> {

    constructor(injector: Injector) {
        super(injector);
        this.filter["type"] = MetaTagType.ORDER_READY_QUALIFIER;
    }

    override getIdentifierField(): string {
        return "metaTagDefinitionId";
    }

    override getResourceName(): string {
        return "meta-tag-definition";
    }

    override getResource(): string {
        return "order-ready-qualifier";
    }
}
